import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { TableCell, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import qs from 'query-string';
import { Collector, CollectorSettingScope } from 'graphql/types';
import { collectorUninstall, isWithinAnotherApp } from 'containerApp';

const useStyles = makeStyles((theme) => ({
  disconnectLink: {
    opacity: '0.6',
    color: theme.palette.grey[600]
  }
}));
type DisconnectCellProps = {
  scope: CollectorSettingScope;
  info: Collector | undefined;
  isAdmin: boolean;
  installId: string;
};

export const DisconnectCell: React.FC<DisconnectCellProps> = ({
  scope,
  info,
  isAdmin,
  installId
}: DisconnectCellProps) => {
  const classes = useStyles();
  const disconnectColor =
    isAdmin || scope === CollectorSettingScope.User ? 'primary' : 'inherit';

  const handleDisconnect = useCallback(
    (collector) => {
      const query = qs.stringify({
        id: collector.id,
        scope: scope
      });
      const { origin } = window.location;
      const url = `${origin}/collector/uninstall?${query}`;
      if (isWithinAnotherApp()) {
        collectorUninstall(url);
      } else {
        window.open(`/collector/uninstall?${query}`);
      }
    },
    [scope]
  );

  const onDisconnect = useCallback((info) => () => handleDisconnect(info), [
    handleDisconnect
  ]);

  return (
    <TableCell>
      <Link
        className={
          isAdmin || scope === CollectorSettingScope.User
            ? ''
            : classes.disconnectLink
        }
        onClick={
          isAdmin || scope === CollectorSettingScope.User
            ? onDisconnect(info)
            : void 0
        }
        href={
          isAdmin || scope === CollectorSettingScope.User
            ? '#installed'
            : void 0
        }
        color={disconnectColor}
        underline="none"
        data-testid={`uninstall-link-${installId}`}
      >
        <FormattedMessage id="collectorSetting.uninstall" />
      </Link>
    </TableCell>
  );
};
export default React.memo(DisconnectCell);
